import * as React from 'react';
import { ErrorMessageContext } from './context.js';

const ErrorMessageProvider = ({ children , initialMessages =[]  })=>{
    const [errors1, setErrors] = React.useState(initialMessages);
    const hasErrors = errors1.length > 0;
    const addError = React.useCallback((error)=>{
        setErrors((errors)=>[
                ...errors,
                error
            ]
        );
    }, []);
    const removeError = React.useCallback((error)=>{
        setErrors((errors)=>errors.filter((e)=>e !== error
            )
        );
    }, []);
    const clearErrors = React.useCallback(()=>setErrors([])
    , []);
    const value = React.useMemo(()=>[
            {
                addError,
                removeError,
                clearErrors
            },
            {
                errors: errors1,
                hasErrors
            }, 
        ]
    , [
        addError,
        errors1,
        hasErrors,
        removeError
    ]);
    return /*#__PURE__*/ React.createElement(ErrorMessageContext.Provider, {
        value: value
    }, children);
};

export { ErrorMessageProvider };
//# sourceMappingURL=provider.js.map
